import { lazyPreparePopoutDataForReadingPane } from 'owa-mail-folder-common';
import { getSelectedTableView } from 'owa-mail-list-store';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import { ClientItem } from 'owa-mail-store';
import { popoutReadingPane } from 'owa-popout';
import * as React from 'react';

export default function onPopout(item: ClientItem, viewState: ItemViewState) {
    return (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();

        popoutReadingPane(viewState.itemId, null /*conversationId*/, item.MailboxInfo, async () => {
            const preparePopoutDataForReadingPane = await lazyPreparePopoutDataForReadingPane.import();
            return preparePopoutDataForReadingPane(getSelectedTableView());
        });
    };
}
